import { UserRepository } from "../../repositories/UserRepository";

/**
 * Get Assignable Managers Use Case
 * Retrieves users who can be assigned as managers
 */
export class GetAssignableManagersUseCase {
  constructor(private repository: UserRepository) {}

  async execute(): Promise<
    Array<{ id: number; email: string; userName?: string; role: string }>
  > {
    return await this.repository.getAssignableManagers();
  }
}
